import React from 'react';

const Picture = ({ alt, srcSet, ...rest }: any) => {
	const fallbackImg = srcSet.find((x: any) => x.fallback === true);
	return (
		<picture {...rest}>
			{srcSet.map((item: any, idx: number) => (
				<source media={item.media} srcSet={item.img} key={idx} />
			))}
			<img src={fallbackImg.img} alt={alt} />
		</picture>
	);
};

export default Picture;
